import { Box, VStack, Heading, Text, Image } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { t } from "i18next";
import { useRef, useState, useEffect } from "react";
import CustomModalPlus from "../customModalPlus";
import Arrow from '../../../assets/images/Caret.png';
import blueArrow from '../../../assets/images/arrow.png';
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { addLineBreaks } from "../../../utils";
import logFirebaseEvents from "../../../components/LogFirebaseEvents";
import buttonBorder from '../../../assets/kudzu-plus-images/gradient-button-square.png';
import LeftArrow from '../../../assets/images/left_arrow.png';
import RightArrow from '../../../assets/images/Right_arrow.png';
import DisableLeftArrow from '../../../assets/images/disable_left.png'
import DisableRightArrow from '../../../assets/images/disable_right.png'

const Slide = ({ heading, paragraph, imageUrl, imageUrlAlter, videoUrl, footerText, imageCenter, isbgTransparent, dynamicfooterStyles, dynamicSubHeaderStyles, dynamicHeaderStyles, width, slackListHeight = "auto", slideRef: slideRefCallback, slideIndex, isLastSlide }) => {
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal ";
    const SubHeaderMsgStyles = "sm:w-[399px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";
    const SubHeaderMsgStylesFooter = "font-hanken-grotesk modal-title text-white  lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";

    return (
        <div ref={slideRefCallback}>
            <VStack
                bg={isbgTransparent ? '' : '#262B3A'}
                border=""
                align="center"
                justify="center"
                gap="15px"
                height={slackListHeight}
            >
                <Heading as="h6"
                    className={`${dynamicHeaderStyles ? dynamicHeaderStyles : HeaderMsgStyles} ${isbgTransparent ? 'text-[#262B3A]' : 'text-white'}`}
                    marginRight={"auto"}
                >
                    {heading}
                </Heading>
                <p
                    className={dynamicSubHeaderStyles ? dynamicSubHeaderStyles : SubHeaderMsgStyles}
                    style={{ marginRight: "auto", marginBottom: isLastSlide ? "0%" : "20%", marginTop: "-5%" }}
                >
                    {paragraph}
                </p>
                {imageUrl ? (
                    <Image className={`bgVid ${paragraph === t("new_wel_extend_para") ? "w-[200px] h-[150px]" : "w-360px h-360px"} md:mr-5`} src={imageUrl} alt={heading} style={{
                        ...(slideIndex === 0 || slideIndex === 1 || slideIndex === 3 ? { marginTop: "15%", marginBottom: "20%" } : {}),
                        marginLeft: "10%"
                    }} />
                ) : (
                    <video
                        className={`${imageCenter ? footerText ? '' : '' : ''} w-full h-auto`}
                        alt={heading}
                        style={{ maxHeight: "299px", maxWidth: "299px", background: "transparent" }}
                        autoPlay
                        muted
                        loop
                        preload="auto"
                        playsInline>
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                )}
                {
                    imageUrlAlter && (<Image className={`bgVid w-500px h-500px md:mr-5`} src={imageUrlAlter} alt={heading} />)
                }
                {footerText && (
                    <div className={`${dynamicfooterStyles ? dynamicfooterStyles : SubHeaderMsgStylesFooter}`} marginRight={"auto"}>
                        {footerText}
                    </div>
                )}
            </VStack>
        </div>
    );
};


export default function CustomCarouselAdaptive({ slidesData, acceptBtnClr, onCancelBtnClickPlusModal, gradientButton, footerTexts, footerbtnContent, finalButtontextChange, forClimbHomeBtn, dotsAbove, forClimbBtn, buttonsEnableForWelcome, ManageMembershipKudzuPlusBtns, isbgTransparent = false, forWelcomeCarousel, dotsHide = false, kudzuplusCheckOnClick, iswelcomeCarouselSkipClick, climNextCallBack, isClimbMenu = false, isNotShowArrow = false }) {
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-white lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300] cursor-pointer";
    const SubHeaderMsgStylesFooter = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)]  lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";
    const slickRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [carouselHeight, setCarouselHeight] = useState("auto");
    const [fixedArrowTop, setFixedArrowTop] = useState(null);
    const slideRefs = useRef({});
    const kudzuFlowFromVal = useSelector(state => state.kudzuFlowFrom);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Update carousel height when slide changes
    useEffect(() => {
        const slideElement = slideRefs.current[currentSlide];
        if (slideElement) {
            // Use a timeout to ensure DOM is updated
            setTimeout(() => {
                const height = slideElement.scrollHeight;
                setCarouselHeight(`${height}px`);
            }, 100);
        }
    }, [currentSlide, slidesData]);

    // Calculate fixed arrow position based on first slide height
    useEffect(() => {
        const calculateFirstSlideCenter = () => {
            const firstSlideElement = slideRefs.current[0];
            if (firstSlideElement) {
                const firstSlideHeight = firstSlideElement.scrollHeight;
                // Set arrow position to center of first slide
                if (firstSlideHeight > 0 && fixedArrowTop === null) {
                    setFixedArrowTop(`${firstSlideHeight / 2}px`);
                }
            }
        };

        // Calculate after first slide is rendered
        const timer = setTimeout(() => {
            calculateFirstSlideCenter();
        }, 400);
        return () => clearTimeout(timer);
    }, [slidesData.length, fixedArrowTop]);


    const slickSettings = {
        dots: dotsAbove ? false : dotsHide ? false : true,
        infinite: true,
        speed: 600,
        autoplay: dotsAbove ? false : false,
        slidesToShow: 1,
        arrows: false,
        afterChange: (current) => {
            setCurrentSlide(current);
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const nextSlide = () => {
        slickRef.current.slickNext();
    };

    const navigateToHome = () => {
        navigate('/home')
    }

    const handleDotClick = (index) => {
        slickRef.current.slickGoTo(index);
    };

    const handleSkip = () => {
        logFirebaseEvents("Carousel", "Skip_Clicked", "Skip_Clicked", "", "");
        if (kudzuFlowFromVal === "Climb" || kudzuFlowFromVal === "climbCoveredByKudzu" || kudzuFlowFromVal === "climFooter" || kudzuFlowFromVal === t('change_pin_success')) {
            if (onCancelBtnClickPlusModal) {
                onCancelBtnClickPlusModal()
            }
        }
        else {
            onCancelBtnClickPlusModal()
        }
    }

    const handleSkipForWelcome = () => {
        navigate('/home')
    }

    const currentSlideData = slidesData[currentSlide] || {};


    return (
        <>
            <Box >
                <Box
                    sx={{
                        ".slick-list": {
                            height: carouselHeight,
                            transition: "height 0.3s ease",
                        },
                        ".slick-dots": {
                            top: dotsAbove ? "130px" : "",
                            bottom: dotsAbove ? "inherit" : '-25px;'
                        },
                        ".slick-dots li": {
                            width: "5px",
                            height: "5px"
                        },
                        ".slick-dots li button::before": {
                            color: "var(--card-bg-profile)",
                            fontSize: "6px",
                            transition: "none",
                        },
                        ".slick-dots li.slick-active button::before": {
                            color: "white",
                        },
                        ".slick-prev, .slick-next": {
                            width: "40px",
                            height: "40px",
                            zIndex: 1,
                            display: "flex !important",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255, 255, 255, 0.2)",
                            borderRadius: "50%",
                            top: "50%",
                            transform: "translateY(-50%)",
                        },
                        ".slick-prev": {
                            left: "10px",
                        },
                        ".slick-next": {
                            right: "10px",
                        },
                        ".slick-prev:before, .slick-next:before": {
                            display: "none",
                        },
                    }}
                    position="relative"
                    style={{ position: 'relative' }}
                >
                    {dotsAbove && slidesData?.length > 0 && (
                        <ul
                            className="slick-top-dots"
                            style={{
                                display: 'block',
                                position: 'absolute',
                                top: '180px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: 15,
                                width: 'auto',
                                pointerEvents: 'auto'
                            }}
                        >
                            {slidesData.map((slide, index) => (
                                <li key={index} className={currentSlide === index ? 'slick-active' : ''} onClick={() => handleDotClick(index)}>
                                    <button>{index + 1}</button>
                                </li>
                            ))}
                        </ul>
                    )}
                    {!isNotShowArrow && fixedArrowTop &&
                        <button
                            className="absolute left-[10px] z-10"
                            onClick={() => currentSlide > 0 ? slickRef.current.slickPrev() : null}
                            disabled={currentSlide === 0}
                            style={{
                                position: 'absolute',
                                top: fixedArrowTop,
                                left: '-20%',
                                transform: 'translateY(calc(-50% + 30px))',
                                pointerEvents: currentSlide === 0 ? 'none' : 'auto',
                                opacity: currentSlide === 0 ? 0.5 : 1,
                                cursor: currentSlide === 0 ? 'not-allowed' : 'pointer',
                                zIndex: 10
                            }}
                        >
                            <img src={currentSlide === 0 ? DisableLeftArrow : LeftArrow} alt="Next" className="w-[36px] h-[32px]" />
                        </button>
                    }
                    <div className="relative scrollbar-hide" style={{ height: carouselHeight, position: 'relative' }}>
                        <Slider ref={slickRef} {...slickSettings}>
                            {slidesData.map((slide, index) => (
                                <Slide
                                    key={index}
                                    slideIndex={index}
                                    isLastSlide={index === slidesData.length - 1}
                                    slideRef={(el) => {
                                        if (el) {
                                            slideRefs.current[index] = el;
                                        }
                                    }}
                                    heading={slide.heading}
                                    paragraph={slide.paragraph}
                                    imageUrl={slide.imageUrl}
                                    imageUrlAlter={slide.imageUrlAlter}
                                    videoUrl={slide.videoUrl}
                                    footerText={slide.footerText}
                                    imageCenter={dotsAbove}
                                    isbgTransparent={isbgTransparent}
                                    carouselAcceptBtnText={slide.carouselAcceptBtnText}
                                    carouselCancelBtnClick={slide.carouselCancelBtnClick}
                                    carouselAcceptBtnClick={slide.carouselAcceptBtnClick}
                                    dynamicfooterStyles={slide.dynamicfooterStyles}
                                    dynamicSubHeaderStyles={slide.dynamicSubHeaderStyles}
                                    dynamicHeaderStyles={slide.dynamicHeaderStyles}
                                    slackListHeight={
                                        slide.slackListHeight === undefined
                                            ? "auto"
                                            : slide.slackListHeight
                                    }
                                />
                            ))}
                        </Slider>
                    </div>
                    {!isNotShowArrow && fixedArrowTop &&
                        <button
                            className="absolute right-[10px] z-10"
                            onClick={() => {
                                if (currentSlide === slidesData.length - 1) return null;
                                slickRef.current.slickNext();
                            }}
                            disabled={currentSlide === slidesData.length - 1}
                            style={{
                                position: 'absolute',
                                top: fixedArrowTop,
                                right: '-20%',
                                transform: 'translateY(calc(-50% + 30px))',
                                 pointerEvents: currentSlide === slidesData.length - 1 ? 'none' : 'auto',
                                opacity: currentSlide === slidesData.length - 1 ? 0.5 : 1,
                                cursor: currentSlide === slidesData.length - 1 ? 'not-allowed' : 'pointer',
                                zIndex: 10
                            }}
                        >
                            <img src={currentSlide === slidesData.length - 1 ? DisableRightArrow : RightArrow} alt="Next" className="w-[36px] h-[32px]" />
                        </button>
                    }
                </Box>
            </Box>

            {currentSlideData.footerTextForUpgrade && (<p className={currentSlideData.dynamicfooterStyles ? currentSlideData.dynamicfooterStyles : SubHeaderMsgStylesFooter} marginRight={"auto"}>
                {currentSlideData.footerTextForUpgrade}
            </p>)}

            {currentSlideData.carouselAcceptBtnText && (
                <button class="borderGradient md:w-[100%] w-full m-auto font-semibold mt-[40px]
        flex items-center lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px]
         justify-center lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk
         leading-[16px] focus:outline-none" onClick={currentSlideData.carouselAcceptBtnClick} style={{ color: 'rgb(255, 255, 255)' }}> {currentSlideData.carouselAcceptBtnText}</button>
            )}

            {currentSlideData.carouselCancelBtnText && (
                <button tabindex="0" id="btn2Ref" class=" w-full mt-5 lg:h-[60px]
       md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px]
        md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] sm:border-0 border-[#2965FB]
         border-[0px] focus:border-[#2965FB] focus:border-[#3px]" onClick={currentSlideData.carouselCancelBtnClick}
                    style={{ color: 'rgb(119, 156, 229)' }}>{currentSlideData.carouselCancelBtnText}</button>
            )}

            {buttonsEnableForWelcome &&
                <div className='flex sm: justify-between md:gap-[18rem] xsm:gap-[130px] sm:gap-48 mt-[25px]'>
                    <button
                        type="button"
                        onClick={handleSkipForWelcome}
                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#779CE5] flex items-center"
                    >
                        {t('skip')}
                    </button>
                    {currentSlide === slidesData.length - 1 ?
                        <button
                            type="button"
                            onClick={navigateToHome}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 400 }}
                        >
                            {t('get_started')}<img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                                alt="Arrow" />
                        </button> : <button
                            type="button"
                            onClick={nextSlide}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 400 }}
                        >
                            {t('next')}<img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                    h-[14px] ml-1"
                                alt="Arrow" />
                        </button>}
                </div>}

            {forClimbBtn && !isClimbMenu &&
                <div className={`flex ${forClimbHomeBtn ? 'sm: justify-between' : 'sm: justify-end'} ${forClimbHomeBtn ? 'md:gap-[18rem]' : 'md:gap-[120px]'} xsm:gap-[130px] sm:gap-48 mt-[25px]`}>
                    <button
                        type="button"
                        onClick={handleSkip}
                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#94C3E8] flex items-center"
                        style={{ fontWeight: 600 }}
                    >
                        {t('skip')}
                    </button>
                    {currentSlide === slidesData.length - 1 ?
                        <button
                            type="button"
                            onClick={() => {
                                logFirebaseEvents("Carousel", "learn_More_Clicked", "learn_More_Clicked", "", "");
                                finalButtontextChange === t('done') ? onCancelBtnClickPlusModal() : climNextCallBack()
                            }}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 600 }}
                        >
                            {finalButtontextChange ? finalButtontextChange : t('Learn_More')}
                            {finalButtontextChange === t('done') ? "" : <img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                                alt="Arrow" />}
                        </button> : <button
                            type="button"
                            onClick={nextSlide}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 600 }}
                        >
                            {finalButtontextChange === t('done') ? t('next') : t('Learn_More')}
                            <img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                                alt="Arrow" />
                        </button>}
                </div>}

            {forClimbBtn && isClimbMenu &&
                <div className={`flex ${forClimbHomeBtn ? 'sm: justify-between' : 'sm: justify-end'} ${forClimbHomeBtn ? 'md:gap-[18rem]' : 'md:gap-[120px]'} xsm:gap-[130px] sm:gap-48 mt-[25px]`}>
                    <button
                        type="button"
                        onClick={handleSkip}
                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#94C3E8] flex items-center"
                        style={{ fontWeight: 600 }}
                    >
                        {t('skip')}
                    </button>
                    {currentSlide === slidesData.length - 1 ?
                        <button
                            type="button"
                            onClick={() => {
                                logFirebaseEvents("Carousel", "learn_More_Clicked", "learn_More_Clicked", "", "");
                                climNextCallBack()
                            }}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 600 }}
                        >
                            {finalButtontextChange ? finalButtontextChange : t('Learn_More')}
                            {finalButtontextChange === t('done') ? "" : <img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                                alt="Arrow" />}
                        </button> : <button
                            type="button"
                            onClick={nextSlide}
                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
                            style={{ fontWeight: 600 }}
                        >
                            {finalButtontextChange !== t('done') ? t('next') : t('Learn_More')}
                            <img
                                src={Arrow}
                                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                                alt="Arrow" />
                        </button>}
                </div>}

            {forWelcomeCarousel &&
                <div className="flex justify-between">
                    <button
                        type="button"
                        onClick={iswelcomeCarouselSkipClick}
                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px]
            md:text-[17px] sm:text-[13px] text-[14px] text-[#94C3E8] cursor-pointer
           flex items-center">
                        {t('Skip')}
                    </button>
                    <button
                        type="button"
                        onClick={currentSlide === slidesData.length - 1 ? kudzuplusCheckOnClick : nextSlide}
                        className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px]
           md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer
           flex items-center">
                        {currentSlide === 0 ? t('payPerksBtn') : t('next')}
                        <img
                            src={blueArrow}
                            className="md:w-[17px] sm:w-[11px] md:h-[17px] sm:h-[11px] w-[12px] h-[12px] ml-2"
                            alt="Arrow"
                        />
                    </button>
                </div>
            }
        </>
    );
}
